module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isShowSaasPro) ? _c('div', {
    staticClass: "saas-pro-hint"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.isShowSaasPro = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('commonheader', {
    on: {
      "getMessageList": function($event) {
        _vm.showMessageList = true
      }
    }
  }), _vm._v(" "), _c('sidemenu', {
    class: {
      'side-menu-class': _vm.isShowSaasPro
    }
  }), _vm._v(" "), _c('router-view', {
    key: _vm.key
  }), _vm._v(" "), (_vm.moduleType) ? _c('dycti', {
    attrs: {
      "xbbCallstatus": _vm.xbbCallstatus
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.showMessageList) ? _c('message-list', {
    ref: "messageList",
    on: {
      "closeMessge": function($event) {
        _vm.showMessageList = false
      },
      "openDeleteBox": _vm.openDeleteBox
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('delete-message', {
    ref: "delete",
    on: {
      "submitDelete": _vm.submitDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "saas-pro-hint-text"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("\n    当前系统数据已经迁移到新系统（请在新系统内完整使用产品），新增数据不会同步到新系统，请勿新增！\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b7167a1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1297
// module chunks = 82